import api from "@/services/api"
import type { CreateUpdateOrderResponse } from "../sharedTypes/orders"

type UpdateOrderRequest = {
  orderItems: Array<{
    productId: string | null
    productModifierIds: string[] | null
    price: number | null
    note: string | null
  }>
  amountGratuity: number
  isOpen: boolean
  isCollection?: boolean
  tableId?: string | null
  note?: string | null
  customerName?: string | null
  customerPhone?: string | null
  collectionAt?: string | null
  serviceChargePercentage?: number | null
  serviceChargeFlat?: number | null
}

export const updateOrder = async (
  orderId: string,
  params: UpdateOrderRequest
) => {
  const { body } = await api.put<CreateUpdateOrderResponse>(
    `/orders/${orderId}/`,
    { body: params }
  )
  return body
}
